import Enumerator from '../global/Enumerator';

export const subscriptionTypes = [
  'MBROKERS',
  'SUBCRM',
  'SUBPROCESSOR',
  'price_1Jrx61GDITq5oTFpoY54Uxgw', // 'WEBLOANQ',
  'PARTNERS',
  'PHONES',
  'PROMNT',
  'PROANN',
  'BUSMNT',
  'BUSANN',
  'NONE'
];

export const subscriptionStatusTypes = [
  'trialing',
  'active',
  'past_due',
  'cancelled',
  'unpaid'
];

export class SubscriptionType extends Enumerator {
  static default() {
    return this.of('NONE');
  }
}
SubscriptionType.initEnum(subscriptionTypes);

export class SubscriptionStatusType extends Enumerator {
  static default() {
    return this.of('trialing');
  }
}
SubscriptionStatusType.initEnum(subscriptionStatusTypes);

export default {
  subscriptionTypes,
  SubscriptionType,
  subscriptionStatusTypes,
  SubscriptionStatusType
};
